import { render, staticRenderFns } from "./dim-overlay.vue?vue&type=template&id=36029014"
import script from "./dim-overlay.vue?vue&type=script&lang=js"
export * from "./dim-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports